import useReactionParameterUnitTypeFilter from 'notebook/integrations/chemistry/useReactionParameterUnitTypeFilter';
import useStoichiometryLotAmountUnitTypeFilter from 'notebook/integrations/chemistry/useStoichiometryLotAmountUnitTypeFilter';
import {
  RowScopedUnitTypeFilterArgs,
  RowScopedUnitTypeFilterResult,
  RowScopedUnitTypeFilterType,
} from 'notebook/tables/search-scoping/rowScopedUnitTypeFilter';

/**
 * Hook that decides how the column's unit type predicate should be narrowed, given the evaluated source cell. It
 * loads whatever data it needs itself.
 */
export type RowScopedUnitTypeFilterHook = (
  args: RowScopedUnitTypeFilterArgs
) => RowScopedUnitTypeFilterResult;

export const ROW_SCOPED_UNIT_TYPE_FILTER_HOOKS: {
  [type in RowScopedUnitTypeFilterType]: RowScopedUnitTypeFilterHook;
} = {
  [RowScopedUnitTypeFilterType.STOICHIOMETRY_LOT_CONCENTRATION]: useStoichiometryLotAmountUnitTypeFilter,
  [RowScopedUnitTypeFilterType.REACTION_PARAMETER_UNIT_TYPE]: useReactionParameterUnitTypeFilter,
};
